import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3611b3c7"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "down-main"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "big-title"
}, "真实小圈   真心交友", -1));

const _hoisted_5 = {
  class: "img-main"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-title"
}, "小圈约-小圈约iOS版", -1));

const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"beian\" data-v-3611b3c7><div data-v-3611b3c7>网站备案/许可证号：<a class=\"beian-link\" target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602011124\" data-v-3611b3c7><span class=\"beian-color\" data-v-3611b3c7>粤公网安备 44010602011124号</span></a></div><div data-v-3611b3c7>网站备案/许可证号：<a class=\"beian-link\" target=\"_blank\" href=\"https://beian.miit.gov.cn/\" data-v-3611b3c7><span class=\"beian-color\" data-v-3611b3c7>粤ICP备2022145697号-1</span></a></div><div data-v-3611b3c7>违法和不良信息举报邮箱：<span class=\"beian-color\" data-v-3611b3c7>xqy888vip@163.com</span></div></div>", 1);

const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "tips-val"
};
const _hoisted_12 = {
  class: "share-desc"
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 点击右上角");

const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "share-desc"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 选择\"浏览器中打开\"");

const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 1,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.down_back,
    class: "down-back"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $setup.mid,
    class: "mid-img"
  }, null, 8, _hoisted_6)]), _createElementVNode("img", {
    src: $setup.icon,
    class: "app-icon"
  }, null, 8, _hoisted_7), _hoisted_8, _createElementVNode("div", {
    class: "down-btn btn-back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.down && $setup.down(...args))
  }, " iOS下载 ")]), _hoisted_9]), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt"
  }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("img", {
    src: $setup.share_point,
    class: "point"
  }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, $setup.isIos ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.liulan,
    class: "safari"
  }, null, 8, _hoisted_18))])])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_19)) : _createCommentVNode("", true)]);
}